/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classNames from 'classnames';
import * as React from 'react';

import { mapToCssModules } from '../common/utilities';
import IModalBodyProps from './ModalBody.props';

/**
 * ModalBody component.
 */
export default class ModalBody extends React.PureComponent<IModalBodyProps> {
    public static defaultProps: Partial<IModalBodyProps> = {
        tag: 'div'
    };

    public render(): JSX.Element {
        const { className, cssModule, tag, id, ...attributes } = this.props;
        const Tag = tag || 'div';
        const classes = mapToCssModules(classNames(className, 'msc-modal__body'), cssModule);
        return <Tag {...attributes} className={classes} />;
    }
}
